import React, { Fragment, useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { buildFlexPackOpenGraph } from '@blocktickets/shared-utils'

import LoadingContext from '../../context/Loading/Loading'

import { getFlexPack } from '../../utilities/api'
import { cacheOrgBranding } from '../../utilities/orgBrandingCache'

import { PageLoadingContainer, ViewFlexPackWrapper } from '../../components'
import OpenGraph from '../../components/OpenGraph/OpenGraph'

export default function ViewFlexPackPage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  let { uuid } = useParams()

  const [flexPack, setFlexPack] = useState()

  useEffect(() => {
    showLoading()
    loadFlexPack()
  }, [uuid])

  const loadFlexPack = () => {
    getFlexPack(uuid)
      .then((res) => {
        const pack = res?.data[0]
        setFlexPack(pack)
        cacheOrgBranding(pack?.organization)
      })
      .catch((err) => console.error(err))
      .finally(() => setTimeout(() => hideLoading(), 700))
  }

  const openGraph = buildFlexPackOpenGraph(flexPack)

  return (
    <Fragment>
      <OpenGraph {...openGraph} />
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta
          name="theme-color"
          content={
            flexPack?.primaryColor ||
            flexPack?.season?.primaryColor ||
            flexPack?.organization?.branding?.primaryColor ||
            '#051b35'
          }
        />
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer organization={flexPack?.organization} />
      ) : (
        <ViewFlexPackWrapper flexPack={flexPack} />
      )}
    </Fragment>
  )
}
